
import { Vue } from "vue-property-decorator";
import { Console, Language } from "@/common/global.ts";

/**
 * Base View
 */
export default class BaseView extends Vue {

    /**
     * [animationClass description]
     *
     * @type {[type]}
     */
    public animationClass: string = "state-animate-out";

    /**
     * [basePath description]
     *
     * @type {[type]}
     */
    public basePath: string = window.historyMode === "history" ? "" : ".";

    /**
     * [classes description]
     *
     * @type {[type]}
     */
    public classes: string = "";

    /**
     * List of available phrases as defined in the Language. The index
     * of the phrase must match the index of the Audio in Constants.
     *
     * @type String[]
     */
    public lang: any;

    /**
     * [name description]
     *
     * @type {[type]}
     */
    public name: string = "view/base";

    /**
     * [constructor description]
     *
     * @return {[type]} [description]
     */
    public constructor() {
        super();

        this.lang = {};

        Object.keys(Language).map((key) => {
            this.lang[key] = (<any> Language)[key] as string;
        });
    }

    /**
     * [mounted description]
     *
     * @return {[type]} [description]
     */
    public mounted() {
        this.attachEvents();
    }

    /**
     * [destroyed description]
     *
     * @return {[type]} [description]
     */
    public destroyed() {
        this.detachEvents();
    }

    /**
     * [attachEvents description]
     *
     * @return {[type]} [description]
     */
    public attachEvents() {
        //
    }

    /**
     * [detachEvents description]
     *
     * @return {[type]} [description]
     */
    public detachEvents() {
        //
    }

    /**
     * [trigger description]
     *
     * @param  {[type]}  eventName: string        [description]
     * @param  {[type]}  options:   any           [description]
     * @param  {Boolean} global:    boolean       [description]
     *
     * @return {[type]}             [description]
     */
    public trigger(eventName: string, options: any = { }, global: boolean = false) {
        if (global) {
            const event = new CustomEvent(eventName, { detail: options });
            window.dispatchEvent(event);
        }
        else {
            this.$emit(eventName, options);
        }
    }

    /**
     * [globalize description]
     *
     * @param  {[type]} key:       string        [description]
     * @param  {[type]} reference: this          [description]
     *
     * @return {[type]}            [description]
     */
    public globalize(key: string, reference: this) {
        window[key] = reference;

        // Log
        console.info("Reference Created: ", key);
    }

    /**
     * [bind description]
     *
     * @param  {...[type]} parameters: string[]    [description]
     *
     * @return {[type]}                [description]
     */
    public bind(...parameters: string[]) {
        const self: IBaseView = <IBaseView> <unknown> this;
        parameters.map((funcName) => {
            self[funcName] = self[funcName].bind(self);
        });
    }

    /**
     * [setState description]
     *
     * @param {string} type State to add
     */
    public setState(type: string): void {
        this.$el.classList.add("state-" + type);
    }

    /**
     * [toggleState description]
     *
     * @param  {string} type State to toggle
     */
    public toggleState(type: string): void {
        if (this.$el.classList.contains("state-" + type)) {
            this.unsetState(type);
        }
        else {
            this.setState(type);
        }
    }

    /**
     * [unsetState description]
     *
     * @param  {string} type State to remove
     */
    public unsetState(type: string): void {
        this.$el.classList.remove("state-" + type);
    }

    /**
     * [unsetAllStates description]
     */
    public unsetAllStates(): void {
        this.$el.className = this.$el.className.replace(/\bstate\-.*?\b/g, "");
    }

    /**
     * Check if Animated In
     */
    public IsAnimatedIn(): boolean {
        return this.$el.classList.contains("state-animate-in");
    }

    /**
     * Check if Animated Out
     */
    public IsAnimatedOut(): boolean {
        return this.$el.classList.contains("state-animate-out");
    }

    /**
     * [AnimateIn description]
     */
    public AnimateIn(onComplete: any = null) {
        if (this.animationClass === "state-animate-in") {
            this.warn("Already animated in.");
            return;
        }

        // Check if preload complete happened
        setTimeout(() => {
            document.body.classList.add("state-preload-complete");
        }, 1000);

        setTimeout(() => {
            this.animationClass = "state-animate-in";
        }, 100);
    }

    /**
     * [AnimateOut description]
     */
    public AnimateOut(onComplete: any = null) {
        if (this.animationClass === "state-animate-out") {
            this.warn("Already animated out.");
            return;
        }

        this.animationClass = "state-animate-out";

        if (onComplete != null) {
            onComplete();
        }
    }

    /**
     * [log description]
     *
     * @param  {...[type]} params [description]
     *
     * @return {[type]}           [description]
     */
    public log(...params: any[]) {
        Console.color("[" + this.name + "] " + params.join(" | "), {
            background: "#00A9A5",
            color: "#f1f1f1",
        });
    }

    /**
     * [warn description]
     *
     * @param  {...[type]} params [description]
     *
     * @return {[type]}           [description]
     */
    public warn(...params: any[]) {
        Console.color("⚠️ [" + this.name + "] " + params.join(" | "), {
            background: "#fff3cd",
            color: "#856404",
        });
    }

}
